import instance from './base.service';

export const inventoryYears = async () => {
  try {
    return await instance.get(`/inventory/years`);
  } catch (error) {
    console.log(error);
  }
};

export const inventoryMakes = async (params) => {
  try {
    const queryString = params ? `?${new URLSearchParams(params).toString()}` : '';
    return await instance.get(`/inventory/makes${queryString}`);
  } catch (error) {
    console.log(error);
  }
};

export const inventoryFilter = async ({ makes, yearId }) => {
  try {
    let queryString = new URLSearchParams({ yearId });

    for (const make of makes) {
      queryString.append('makeIds', make);
    }

    return await instance.get(`/inventory/filter?${queryString.toString()}`);
  } catch (error) {
    console.log(error);
  }
};

export const inventoryModels = async ({ filters, makes, yearId }) => {
  try {
    let queryString = new URLSearchParams({ yearId });

    for (const make of makes) {
      queryString.append('makeIds', make);
    }

    for (const filter in filters) {
      for (const value of filters[filter]) {
        queryString.append(filter, value);
      }
    }

    return await instance.get(`/inventory/models?${queryString.toString()}`);
  } catch (error) {
    console.log(error);
  }
};
